import React from "react";
import { Search, Calendar, Filter, UserRound } from "lucide-react";
import FilterDropdown from "./FilterDropdown";
import { useSelector } from "react-redux";

const SalesFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  dateFilter,
  onDateChange,
  onCustomDateSelect,
  creatorFilter,
  onCreatorChange,
  onClearFilters,
  creators = [],
}) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);
  const statusOptions = [
    { value: "all", label: "All Status" },
    { value: "draft", label: "Draft" },
    { value: "publish", label: "Publish" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const dateOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last_7_days", label: "Last 7 Days" },
    { value: "this_month", label: "This Month" },
    { value: "custom", label: "Custom Date" },
  ];

  // Create dynamic creator options from the sales data
  const creatorOptions = [
    { value: "all", label: "All Creator", icon: UserRound },
    ...(creators || []).map((creator) => ({
      value: creator?.id?.toString() || "",
      label: creator?.name || `User ${creator?.id || ""}`,
      icon: UserRound,
    })),
  ];

  return (
    <div className="sales-filters">
      <div className="sales-search">
        <div className="sales-search-input-container">
          <Search size={16} className="sales-search-icon" />
          <input
            type="text"
            className={
              isPartsURL
                ? "sales-search-input-parts"
                : isAccessoriesURL
                ? "sales-search-input-acc"
                : "sales-search-input"
            }
            placeholder="Search by customer name, invoice id or amount..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className="sales-filter-controls">
        <FilterDropdown
          icon={Calendar}
          value={dateFilter}
          onChange={onDateChange}
          options={dateOptions}
          placeholder="This Month"
          showDatePicker={true}
          onDateSelect={(dateRange) => {
            onDateChange("custom");
            onCustomDateSelect(dateRange);
          }}
        />

        <FilterDropdown
          icon={Filter}
          value={statusFilter}
          onChange={onStatusChange}
          options={statusOptions}
          placeholder="All Status"
        />

        <FilterDropdown
          icon={UserRound}
          value={creatorFilter}
          onChange={onCreatorChange}
          options={creatorOptions}
          placeholder="All Creator"
        />

        <button
          className={
            isPartsURL
              ? "sales-clear-filters-btn-parts"
              : isAccessoriesURL
              ? "sales-clear-filters-btn-acc"
              : "sales-clear-filters-btn"
          }
          onClick={onClearFilters}
        >
          Clear Filter
        </button>
      </div>
    </div>
  );
};

export default SalesFilters;
